export const state = () => ({
  dark: {
    type: 'dark-pickled-bluewood',
    variant: null
  },
  light: {
    type: 'light',
    variant: 'bg-white'
  }
})

export default {
  namespaced: true,
  state
}
